import type { CSSProperties } from "react";
import { ReadinessRing } from "../display/ReadinessRing";

export interface ReadinessChipProps {
  /** 0–100 */
  value: number;
  /** ring px */
  size?: number;
  /** override eyebrow label */
  label?: string;
  style?: CSSProperties;
  className?: string;
}

export function ReadinessChip({
  value,
  size = 20,
  label = "READINESS",
  style,
  className,
}: ReadinessChipProps) {
  const n = Math.max(0, Math.min(100, Math.round(value)));

  return (
    <div
      className={className}
      aria-label={`Readiness ${n} of 100`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "4px 10px 4px 8px",
        borderRadius: "var(--r-sm)",
        border: "1px solid var(--line)",
        background: "var(--bg-elev)",
        ...style,
      }}
    >
      <ReadinessRing value={n} size={size} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          lineHeight: 1.1,
        }}
      >
        <span
          style={{
            fontSize: 10,
            fontFamily: "var(--font-mono)",
            color: "var(--ink-3)",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--ink-1)",
          }}
        >
          {n}
          <span style={{ color: "var(--ink-3)" }}>/100</span>
        </span>
      </div>
    </div>
  );
}
